import React from 'react';
export const PhoneLandscape = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`btfont ${props.className ? props.className : ''}`}><path d="M1 4.5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-6zm-1 6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v6z" fillRule="evenodd" />,
<path d="M14 7.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0z" fillRule="evenodd" /></svg>
);
